import { render, staticRenderFns } from "./IntegrationSettingsPage.vue?vue&type=template&id=3ef6709a&scoped=true&"
import script from "./IntegrationSettingsPage.vue?vue&type=script&lang=js&"
export * from "./IntegrationSettingsPage.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationSettingsPage.vue?vue&type=style&index=0&id=3ef6709a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef6709a",
  null
  
)

export default component.exports